<template>
	<transition name="badge" type="animation" @after-enter="completeEntrance">
		<Badge class="kitty-karma" :img="$store.state.config.general.kitty_karma.icon.sizes.large">
			-<AnimatedNumber :number="lostPoints" class="count" />
			<span class="label">Points</span>
		</Badge>
	</transition>
</template>

<script>
import AnimatedNumber from '@/components/abstract/AnimatedNumber';
import Badge from '@/components/abstract/Badge';
import { mapState } from 'vuex';

export default {
	name: 'KittyKarma',
	components: {
		AnimatedNumber,
		Badge,
	},
	computed: {
		...mapState({
			killedCount: state => state.cycle.actions.killed,
			multiplier: state => state.config.general.score_multipliers.dead_cats,
		}),
	},
	data() {
		return {
			lostPoints: 0,
		};
	},
	methods: {
		completeEntrance() {
			this.lostPoints = this.killedCount * this.multiplier;
		},
	},
};
</script>

<style lang="scss" scoped>
	$badge-height: 110px;

	.kitty-karma {
		padding: .5em 0;
	}

	.count {
		font-size: 28px;
		margin-right: .25ch;
	}

	.label {
		letter-spacing: .07em;
	}


	.badge-enter {
		height: 0;
	}

	.badge-enter-to {
		height: $badge-height;
	}

	.badge-enter-active {
		transition: all $ui-transition-duration;
		animation-name: fadeInUp;
		animation-duration: $ui-transition-duration;
	}

	.badge-leave-active {
		animation-name: fadeOutDown;
		animation-duration: $ui-transition-duration;
		animation-delay: $ui-transition-duration;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/KittyKarma.vue